import React, { useState } from "react";
import ExamHistoryCards from "./ExamHistoryCards.component";

const ExamHistoryTable = () => {
  const [examData] = useState([
    {
      id: "exam-101",
      examName: "First Terminal Examination (All)",
      startDate: "27 Dec, 2024",
      endDate: "07 Jan, 2025",
      classes: [
        {
          id: "cls-1",
          className: "Class 6",
          status: "Completed",
          result: "View result",
        },
        {
          id: "cls-2",
          className: "Class 5",
          status: "Postponed",
          result: "Not published",
        },
        {
          id: "cls-3",
          className: "Class 8",
          status: "Postponed",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-102",
      examName: "Mid-Year Examination",
      startDate: "15 Mar, 2025",
      endDate: "25 Mar, 2025",
      classes: [
        {
          id: "cls-4",
          className: "Class 7",
          status: "Completed",
          result: "View result",
        },
        {
          id: "cls-5",
          className: "Class 9",
          status: "Cancelled",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-103",
      examName: "Annual Examination",
      startDate: "05 Apr, 2025",
      endDate: "20 Apr, 2025",
      classes: [
        {
          id: "cls-6",
          className: "Class 10",
          status: "Scheduled",
          result: "Not published",
        },
        {
          id: "cls-7",
          className: "Class 8",
          status: "Scheduled",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-104",
      examName: "Quarterly Test",
      startDate: "10 Feb, 2025",
      endDate: "15 Feb, 2025",
      classes: [
        {
          id: "cls-8",
          className: "Class 4",
          status: "Completed",
          result: "View result",
        },
        {
          id: "cls-9",
          className: "Class 6",
          status: "Completed",
          result: "View result",
        },
      ],
    },
    {
      id: "exam-105",
      examName: "Science Olympiad",
      startDate: "12 Jan, 2025",
      endDate: "13 Jan, 2025",
      classes: [
        {
          id: "cls-10",
          className: "Class 7",
          status: "Completed",
          result: "View result",
        },
        {
          id: "cls-11",
          className: "Class 9",
          status: "Completed",
          result: "View result",
        },
      ],
    },
    {
      id: "exam-106",
      examName: "Mathematics Test",
      startDate: "22 Feb, 2025",
      endDate: "24 Feb, 2025",
      classes: [
        {
          id: "cls-12",
          className: "Class 5",
          status: "Cancelled",
          result: "Not published",
        },
        {
          id: "cls-13",
          className: "Class 6",
          status: "Cancelled",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-107",
      examName: "Half-Yearly Examination",
      startDate: "01 Sep, 2025",
      endDate: "15 Sep, 2025",
      classes: [
        {
          id: "cls-14",
          className: "Class 8",
          status: "Scheduled",
          result: "Not published",
        },
        {
          id: "cls-15",
          className: "Class 10",
          status: "Scheduled",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-108",
      examName: "Unit Test - 1",
      startDate: "05 May, 2025",
      endDate: "08 May, 2025",
      classes: [
        {
          id: "cls-16",
          className: "Class 3",
          status: "Completed",
          result: "View result",
        },
        {
          id: "cls-17",
          className: "Class 4",
          status: "Completed",
          result: "View result",
        },
      ],
    },
    {
      id: "exam-109",
      examName: "Unit Test - 2",
      startDate: "10 Jul, 2025",
      endDate: "13 Jul, 2025",
      classes: [
        {
          id: "cls-18",
          className: "Class 6",
          status: "Postponed",
          result: "Not published",
        },
        {
          id: "cls-19",
          className: "Class 7",
          status: "Postponed",
          result: "Not published",
        },
      ],
    },
    {
      id: "exam-110",
      examName: "Language Proficiency Exam",
      startDate: "02 Oct, 2025",
      endDate: "05 Oct, 2025",
      classes: [
        {
          id: "cls-20",
          className: "Class 9",
          status: "Scheduled",
          result: "Not published",
        },
        {
          id: "cls-21",
          className: "Class 10",
          status: "Scheduled",
          result: "Not published",
        },
      ],
    },
  ]);
  return (
    <table id="examHistoryTable">
      <thead>
        <tr>
          <th>Exam Name</th>
          <th>Participating classes</th>
          <th>Exam status</th>
          <th>Exam routine</th>
          <th>Exam result</th>
        </tr>
      </thead>

      <tbody>
        {examData?.map((data, key) => {
          return (
            <ExamHistoryCards
              key={key}
              examName={data?.examName}
              startDate={data?.startDate}
              endDate={data?.endDate}
              classes={data?.classes}
              path="examdetails/abcd"
            />
          );
        })}
      </tbody>
    </table>
  );
};

export default ExamHistoryTable;
